import { ChevronLeft } from "lucide-react";
import { Link } from "react-router-dom";

interface BackHeaderProps {
  to: string;
  title: string;
}

export const BackHeader = ({ to, title }: BackHeaderProps) => {
  return (
    <header className="relative flex h-12 items-center justify-center">
      <Link
        to={to}
        aria-label="Back"
        className="absolute left-0 flex h-10 w-10 items-center justify-center text-primary"
      >
        <ChevronLeft className="h-6 w-6" />
      </Link>
      <h1 className="font-semibold text-lg text-zinc-900">{title}</h1>
    </header>
  );
};
